// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper_1AIKm","placeholder":"Select_placeholder_1Kk0r","select":"Select_select_1Ve_n"};